import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Table from '@tables/table'
import AddPlatformDialog from '@dialogs/add-platform-dialog'
import EditPlatformDialog from '@dialogs/edit-platform-dialog'
import * as utils from '@utils'
import SingleConfirmMsgDialog from '@msg/single-confirm-msg-dialog'
import { API } from '@const'
import { Edit } from '@material-ui/icons'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import { Grid, Switch, Button } from '@material-ui/core'
import EditSingleWalletDialog from '@dialogs/edit-single-wallet-dialog'

const COMPONENT_GROUP = 'platform'

class PlatformPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'PlatformPage')
        }
    }

    state = {
        apiStatus: 'all',
        cmsStatus: 'all'
    }

    actions = []
    columns = [
        {
            field: 'created_at',
            type: 'datetime',
        },
        {
            field: 'pf_id',
            translate: {
                dataKey: 'pf_id',
                tranKey: 'Platform',
            },
        },
        { field: 'name' },
        {
            field: 'pf_sub_pf_id',
            title: 'PF ID',
        },
        {
            field: 'primary_sub_pf_key',
            title: 'Private Key',
            render: (row) => {
                if ((row.primary_sub_pf_key && row.secondary_sub_pf_key)) {
                    return (<div>
                        <div style={{whiteSpace: 'nowrap'}}>key1：{row.primary_sub_pf_key}</div>
                        <div style={{whiteSpace: 'nowrap', paddingTop: '8px'}}>key2：{row.secondary_sub_pf_key}</div>
                    </div>)
                } else {
                    return <div>{row.primary_sub_pf_key || row.secondary_sub_pf_key}</div>
                }
            }
        },
        {
            field: 'is_support_single',
            // type: 'is_support_single',
            render: (row) => {
                if (row.is_support_single) {
                    if (
                        utils.checkValid('single_wallet.view') &&
                        utils.checkValid('single_wallet.register') &&
                        utils.checkValid('single_wallet.edit') &&
                        utils.checkValid('single_wallet.validate')
                    ) {
                        return (
                            <Button
                                style={{ minWidth: '120px' }}
                                onClick={() => {
                                    utils.apiRequest(
                                        'get',
                                        API.SINGLE_WALLET,
                                        {pf_sub_pf_id: row.pf_sub_pf_id},
                                        (data) => {
                                            this.editSingleWalletDialog.OpenDialog(row.pf_sub_pf_id, data)
                                        },
                                        () => {
                                            this.editSingleWalletDialog.OpenDialog(row.pf_sub_pf_id, {})
                                        }
                                    )
                                }}
                                color="primary"
                            >
                                <Edit />
                                {this.t('editAndTest')}
                            </Button>
                        )
                    }
                    return (
                        <div style={{textAlign: 'center'}}>V</div>
                    )
                }
                return ''
            }
        },
        {
            field: 'updated_at',
            type: 'datetime',
        },
        {
            field: 'is_active',
            title: utils.t('apiStatus', 'PlatformPage'),
            type: 'action',
            render: (rowData) => {
                if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
                    return <Switch
                        checked={rowData.is_active}
                        onChange={(event) => {
                            this.statusConfirmDialog.OpenDialog({
                                type: 'info',
                                msg: this.t('confirmSwitchMsg'),
                                confirmParams: { checked: event.target.checked },
                                confirm: (params) => {
                                    utils.apiRequest(
                                        'patch',
                                        API.PLATFORM_EDIT,
                                        {
                                            is_active: params.checked,
                                            is_display: rowData.is_display,
                                            name: rowData.name,
                                            pf_sub_pf_id: rowData.pf_sub_pf_id
                                        },
                                        (_data) => {
                                            this.statusConfirmDialog.closeDialog()
                                            Promise.all([
                                                new Promise((resolve) => {
                                                    this.props.dataServiceInit(resolve)
                                                }),
                                            ]).then(() => {
                                                this.queryData()
                                            })
                                        }
                                    )
                                },
                            })
                        }}
                        value="Status"
                        color="primary"
                        inputProps={{ 'aria-label': 'Status' }}
                    />
                } else {
                    return rowData.is_active ? (<div className={this.props.classes.enable}>{utils.t('enable')}</div>) : (<div className={this.props.classes.disable}>{utils.t('disable')}</div>)
                }
            }
        },
        {
            field: 'is_display',
            title: utils.t('cmsStatus', 'PlatformPage'),
            type: 'action',
            render: (rowData) => {
                if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
                    return <Switch
                        checked={rowData.is_display}
                        onChange={(event) => {
                            this.statusConfirmDialog.OpenDialog({
                                type: 'info',
                                msg: this.t('confirmSwitchMsg'),
                                confirmParams: { checked: event.target.checked },
                                confirm: (params) => {
                                    utils.apiRequest(
                                        'patch',
                                        API.PLATFORM_EDIT,
                                        {
                                            is_display: params.checked,
                                            is_active: rowData.is_active,
                                            name: rowData.name,
                                            pf_sub_pf_id: rowData.pf_sub_pf_id
                                        },
                                        (_data) => {
                                            this.statusConfirmDialog.closeDialog()
                                            Promise.all([
                                                new Promise((resolve) => {
                                                    this.props.dataServiceInit(resolve)
                                                }),
                                            ]).then(() => {
                                                this.queryData()
                                            })
                                        }
                                    )
                                },
                            })
                        }}
                        value="Status"
                        color="primary"
                        inputProps={{ 'aria-label': 'Status' }}
                    />
                } else {
                    return rowData.is_display ? (<div className={this.props.classes.enable}>{utils.t('enable')}</div>) : (<div className={this.props.classes.disable}>{utils.t('disable')}</div>)
                }
            }
        }
    ]

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.add') || utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.actions.push({
                icon: 'loop',
                text: 'refresh',
                isFreeAction: true,
                onClick: () => {
                    this.refreshList()
                },
            })
        }
        /** 新增 / 編輯權限 */
        this.updateTableColumns()
        this.queryData()
    }
    
    updateTableColumns() {
        if (utils.checkValid(COMPONENT_GROUP + '.add')) {
            this.actions.push({
                icon: 'add',
                text: 'add',
                isFreeAction: true,
                onClick: () => {
                    this.addDialog.OpenDialog()
                },
            })
        }
        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push(
                {
                    field: 'edit',
                    type: 'edit',
                    export: false,
                    render: (rowData) => {
                        return (
                            <Button
                                style={{ minWidth: '72px' }}
                                onClick={() => {
                                    this.editDialog.OpenDialog(rowData)
                                }}
                                color="primary">
                                <Edit />
                                {this.t('edit')}
                            </Button>
                        )
                    },
                }
            )
        }
    }

    queryData() {
        this.table.SetLoading(true)
        const data = this.filterData(Object.values(this.props.dataService.pfSubPfMap))
        this.table.SetData(data)
    }

    filterData(data) {
        return data.filter(item => {
            if (this.state.apiStatus === 'all') {
                return item
            } else {
                const apiStatus = this.state.apiStatus === 'enable'
                return item.is_active === apiStatus
            }
        }).filter(item => {
            if (this.state.cmsStatus === 'all') {
                return item
            } else {
                const cmsStatus = this.state.cmsStatus === 'enable'
                return item.is_display === cmsStatus
            }
        })
    }

    refreshList() {
        utils.apiRequest(
            'post',
            API.SUB_PLATFORM_REFRESH,
            null,
            (_data) => {
                window.location.reload()
            },
            null,
            true
        )
    }

    sleep = (milliseconds) => {
        return new Promise((resolve) => setTimeout(resolve, milliseconds))
    }

    render() {
        return (
            <Grid container spacing={2}>
                {/* <Grid item xs={12}>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel>{this.t('apiStatus')}</InputLabel>
                        <Select
                            value={this.state.apiStatus}
                            onChange={(event) =>
                                this.setState({
                                    apiStatus: event.target.value,
                                })
                            }>
                            <MenuItem value="all">{this.t('all')}</MenuItem>
                            <MenuItem value="enable">{this.t('enable')}</MenuItem>
                            <MenuItem value="disable">{this.t('disable')}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel>{this.t('cmsStatus')}</InputLabel>
                        <Select
                            value={this.state.cmsStatus}
                            onChange={(event) =>
                                this.setState({
                                    cmsStatus: event.target.value,
                                })
                            }>
                            <MenuItem value="all">{this.t('all')}</MenuItem>
                            <MenuItem value="enable">{this.t('enable')}</MenuItem>
                            <MenuItem value="disable">{this.t('disable')}</MenuItem>
                        </Select>
                    </FormControl>
                    <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.queryData()}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid> */}
                <Grid item xs={12}>
                    <Table ownerName="PlatformPage" columns={this.columns} actions={this.actions} onRef={(ref) => (this.table = ref)} />
                    <AddPlatformDialog
                        confirmCallback={(subPfID, checkedPfIDList, currentAddPlatform, cmsUser) => {
                            this.table.SetLoading(true)
                            Promise.all([
                                new Promise((resolve) => {
                                    this.props.dataServiceInit(resolve)
                                }),
                            ]).then(() => {
                                this.queryData()
                                const infoList = []
                                checkedPfIDList.forEach((pfID) => {
                                    const pfSubPfID = utils.ComposePfSubPfId(pfID, subPfID.toUpperCase())
                                    const pfInfoKey = currentAddPlatform[pfSubPfID]
                                    let info = `[ ${this.t('Currency.' + utils.getPfCurrency(pfID))} (${this.t('Platform.' + pfID)}) ]\n`
                                    info += `PF ID: ${pfSubPfID}\n`
                                    info += `Private Key: `
                                    info += `${pfInfoKey || ''}\n`

                                    infoList.push(info)
                                })

                                if (cmsUser) {
                                    let cmsUserInfo = `[ ${this.t('cmsUserInfo')} ]\n`
                                    Object.entries(cmsUser).forEach(([key, value]) => {
                                        cmsUserInfo += `${this.t(key)}: ${value}\n`
                                    })
                                    infoList.push(cmsUserInfo)
                                }
                                infoList.push(`\n如未正常顯示結果，請按「刷新」清除快取後並搜尋${subPfID}\n`)

                                this.confirmDialog.OpenDialog({
                                    type: 'info',
                                    msg: infoList.join('\n'),
                                })
                            })
                            this.table.SetLoading(false)
                        }}
                        onRef={(ref) => (this.addDialog = ref)}
                    />
                    <EditPlatformDialog
                        confirmCallback={() => {
                            this.table.SetLoading(true)
                            Promise.all([
                                new Promise((resolve) => {
                                    this.props.dataServiceInit(resolve)
                                }),
                            ]).then(() => {
                                this.queryData()
                            })
                            this.table.SetLoading(false)
                        }}
                        onRef={(ref) => (this.editDialog = ref)}
                    />
                </Grid>
                <SingleConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} hideCancel={true} />
                <ConfirmMsgDialog onRef={(ref) => (this.statusConfirmDialog = ref)}/>
                <EditSingleWalletDialog onRef={(ref) => (this.editSingleWalletDialog = ref)} />
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {
        formControl: {
            margin: _theme.spacing(1),
            width: '150px',
        },
        button: {
            margin: _theme.spacing(1),
        },
        enable: {
            color: "#4caf50"
        },
        disable: {
            color: "#dc004e"
        }
    }
}

PlatformPage.propTypes = {
    classes: PropTypes.object,
    dataService: PropTypes.object,
    dataServiceInit: PropTypes.func,
}

export default hoc(styles)(PlatformPage)
